import React from 'react';
import { formatDateTime } from '@/utils/helpers';

const Time = ({ children, ...props }: { children: React.ReactChild }) => {
  return <span {...props}>{formatDateTime(children as string)}</span>;
};

export default Time;
